<script setup>
import { vMaska } from "maska/vue"

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    placeholder: {
        type: String,
        required: true
    },
    value: {
        type: String,
        default: ''
    },
    error: {
        type: String,
        default: ''
    },
    inputClasses: {
        type: String,
        default: ''
    },
    mask: {
        type: [String, Boolean],
        default: false
    }
});

</script>
<template>
    <div class="tw-mb-4">
        <div class="tw-flex tw-items-center">
            <input
                class="input-text"
                :class="[error && 'tw-border-red', inputClasses]"
                :placeholder="props.placeholder"
                type="text"
                :name="props.name"
                :value="props.value"
                v-maska="mask"
                @input="$emit('update', $event.target.value)"
            >
            <slot />
        </div>
        <p v-if="error" class="tw-text-sm tw-mb-4 tw-mt-2 tw-text-red tw-block">{{ error }}</p>
    </div>
</template>
